import { Injectable } from '@angular/core';
import { DataService } from './data.service';

function _window() : any {
  return window;
}

@Injectable()
export class NotificationService {

  public notification:any;

  constructor(private _data:DataService) {}

  get nativeWindow():any {
    return _window();
  }

  public getPermissions():boolean {
    this.notification = this.nativeWindow.Notification || this.nativeWindow.mozNotification || this.nativeWindow.webkitNotification;

    if (typeof this.notification !== 'undefined' || !this.hasPermission) {
      this.notification.requestPermission(function(permission){});
      return true;
    }
  }

  public notify(title:string, content:string, file:string = "logo_notification.png"):void {
    var self = this;
    var notificar = new Notification (
      title, {
      body: content,
      dir: 'auto',
      lang: self._data.configuration["language"],
      tag: 'notificationPopup',
      icon: 'assets/img/'+file
      }
    );
  }

  public hasPermission():boolean {
    switch (this.notification.permission) {
      case "granted":
        return true;
      case "denied":
        return false;
      default:
        return false;
    }
  }

}
